import { UserWrapper } from '../../entityWrappers/UserWrapper';
import { BackendWrapper } from '../../wrappers/BackendWrapper';
import { RuleDefinitionsWrapper } from '../RuleDefinitionsWrapper';
import { TargetsWrapper } from '../TargetsWrapper';
import { wrapperIdentifier } from './common';
import { WrapperBuilder } from '../../builders/wrapperBuilder';
import {
  ComponentWrapperProps,
  InternalContextVariables,
  ExternalContextVariables,
  InternalContextFunctions,
  ExternalContextFunctions,
  ContextState,
  Virtuals,
  Statics,
  BindedWrapperProperties,
  Hooks,
} from './interfaces';

export const wrapperBuilder = new WrapperBuilder<
  ComponentWrapperProps,
  InternalContextVariables,
  {},
  ExternalContextVariables,
  InternalContextFunctions,
  {},
  ExternalContextFunctions,
  ContextState,
  Virtuals,
  Statics,
  BindedWrapperProperties,
  {},
  Hooks
>(wrapperIdentifier, wrapperIdentifier, [
  UserWrapper,
  BackendWrapper,
  RuleDefinitionsWrapper,
  TargetsWrapper,
]);
